{
  "booking": {
    "comment": {
      "label": "Comment",
      "placeholder": "Please feel free to share more feedback :)\nDo you feel closer to your team?\nWould you like to do another event soon?"
    },
    "authorName": {
      "label": "Full name",
      "placeholder": "John Doe"
    },
    "heading": "What are your thoughts on this event?",
    "rating": {
      "high": "Excellent",
      "label": "Rating",
      "low": "Poor"
    }
  },
  "nps": {
    "comment": {
      "label": "Comment",
      "placeholder": "Please feel free to share more feedback :)\nDo you feel closer to your team?\nWould you like to do another event soon?"
    },
    "heading": "Based on this event, how likely are you to recommend Jurnee to a colleague?",
    "rating": {
      "label": "Rating"
    }
  },
  "partnerProvider": {
    "avgRating_GOOGLE_MAPS": "<rating>{{rating}}</rating> <count>({{count}}) on Google Maps</count>",
    "avgRating_TRIPADVISOR": "<rating>{{rating}}</rating> <count>({{count}}) on TripAdvisor</count>"
  },
  "publishedOn": "Published on {{date}}",
  "publishedOn_GOOGLE_MAPS": "Published on Google Maps on {{date}}",
  "publishedOn_TRIPADVISOR": "Published on TripAdvisor on {{date}}",
  "reviewsCount": "based on {{count}} reviews",
  "thanks": {
    "heading": "Thank you",
    "subheading": "so much for your feedback :)"
  },
  "toasts": {
    "fetchBooking": {
      "error": "An error occurred while retrieving the booking"
    },
    "submitReview": {
      "error": "An error occurred while submitting your review"
    }
  }
}